export default __webpack_public_path__ + "static/media/trashcan-disabled.ca69d6c9.svg";